import React from 'react';
import './ChatPanelSourcesHeader.css';

interface ChatPanelSourcesHeaderProps {
  sourceCount: number;
  onClose: () => void;
}

const ChatPanelSourcesHeader: React.FC<ChatPanelSourcesHeaderProps> = ({ sourceCount, onClose }) => {
  return (
    <div className="chat-panel-sources-header">
      <div className="sources-header-text">
        <span className="sources-header-title">Sources</span>
        <span className="sources-header-count"> • {sourceCount} items</span>
      </div>
      <button className="sources-close-button" onClick={onClose}>
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path d="M12.9819 0.684968C13.4505 1.1536 13.4505 1.9134 12.9819 2.38202L8.364 7.00016L12.9819 11.6183C13.4115 12.0479 13.4473 12.7221 13.0893 13.1925L12.9819 13.3154C12.5132 13.784 11.7535 13.784 11.2848 13.3154L6.66667 8.6975L2.04853 13.3154C1.5799 13.784 0.820101 13.784 0.351472 13.3154C-0.117157 12.8467 -0.117157 12.0869 0.351472 11.6183L4.96933 7.00016L0.351472 2.38202C-0.0781048 1.95245 -0.113903 1.27821 0.244078 0.807854L0.351472 0.684968C0.820101 0.216339 1.5799 0.216339 2.04853 0.684968L6.66667 5.30283L11.2848 0.684968C11.7535 0.216339 12.5132 0.216339 12.9819 0.684968Z" fill="#A6A6A6" />
        </svg>
      </button>
    </div>
  );
};

export default ChatPanelSourcesHeader;
